<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard6.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">Realiza un pago de <span style="color: #B3DB5A">${{this.monto}}</span> para apartarlo</h1>
            <h5 style="font-weight: bold;" class="mt-3">Apartado 100% reembolsable.</h5>

        <div class="col-lg-12">
        <b-row align-h="center" class="p-3 mb-5 bg-body rounded">
            <b-col lg="4" style="background-color: #F4F6F6 " class="text-left shadow-sm p-3 rounded card-information">
              <b-row cols="1">
                <b-col><h2 class="h2R">Datos de Reserva</h2></b-col>
                <b-col><h4 class="h4R">Cliente</h4></b-col>
                <b-col><h4 class="h4C">{{this.nombre}} <br> {{this.mail}} <br> (+52) {{this.telefono}}</h4></b-col>
              </b-row>

              <b-row v-for="auto in autos" :key="auto.vin" cols="1" class="mt-5">
                <b-col><h4 class="h4R mt-1">Agencia</h4></b-col>
                <b-col><h4 class="h4R">{{ auto.dealerShip }}</h4><h4 class="h4C">{{ auto.address }}</h4></b-col>
              </b-row>
            </b-col>
            <!-- <b-col v-if="this.autoReservado == true" class="text-left rounded" >
              <b-row class="justify-content-md-center mt-4">
              <b-img src="../assets/unidad_no_disponible.png"  class="img_nd mb-4 mt-4" fluid alt=""></b-img>
              <b-col sm="7" md="7" lg="7" >
              <b-alert v-model="autoReservado" class="text-center mt-4" variant="danger"><b-icon class="mr-1" ></b-icon> Unidad no disponible</b-alert>
                   <b-button @click.prevent="inicio()" class="button_c">INTENTAR OTRA UNIDAD</b-button>
              </b-col>
              </b-row>
            </b-col>   -->
            <b-col class="text-left p-3 rounded" >
                <b-form @submit="onSubmit">
                <b-row class="justify-content-md-center mt-4">
                  <b-col  sm="5" md="5" lg="5">
                    <h6>Tarjetas de Crédito</h6>
                    <b-img src="../assets/TC.png" class="img_c" fluid alt=""></b-img>
                  </b-col>
                  <b-col  sm="5" md="5" lg="5">
                    <h6>Tarjetas de Débito</h6>
                    <b-img src="../assets/TD.png" class="img_d" fluid alt=""></b-img>
                  </b-col>
                </b-row>
                <b-row class="justify-content-md-center mt-4">
                  <b-col col sm="6" md="6" lg="6">
                    <b-form-group id="input-group-1" class="text-left" label-for="input-1">
                        <h6>Nombre del titular de la tarjeta*</h6>
                    <b-form-input id="input-1" v-model="form.nombreTitular" type="text" class="inputInfo" placeholder=""  maxlength="30" onkeypress="return (event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))" required autofocus></b-form-input>
                    </b-form-group>
                  </b-col>
                  
                    <b-col  sm="5" md="5" lg="5">
                    <h6>Fecha Expiración</h6>
                      <b-row>
                        <b-col cols="2" lg="4">
                            <b-form-group id="input-group-2" class="text-left" label-for="input-2">
                            <b-form-input id="input-2" v-model="form.mesTarjeta" class="boderInput inputInfo" type="text" placeholder="MM" maxlength="2" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2" lg="1">
                            <b-form-group id="input-group-3" class="text-left" label-for="input-3">
                            <b-form-input id="input-3" v-model="form.anioTarjeta" class="boderInput inputInfo ml-2" type="text" placeholder="AA" maxlength="2" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                            </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>


                  <b-col  sm="6" md="6" >
                    <b-form-group id="input-group-4" class="text-left" label-for="input-4">
                        <h6>Número de tarjeta</h6>
                    <b-form-input id="input-4" v-model="form.numeroTarjeta"  class="boderT inputInfo" type="text" placeholder=""  maxlength="16" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group> 
                  </b-col>
                  <b-col v-if="this.form.numeroTarjeta.substring(0,2) == 34 || this.form.numeroTarjeta.substring(0,2) == 37" sm="4" md="4" lg="4">
                    <b-form-group id="input-group-5" class="text-left" label-for="input-5">
                        <h6>CVVV</h6>
                    <b-form-input id="input-5" v-model="form.cvvTarjeta" class="boderCVV inputInfo" type="password" placeholder="CVVV"  maxlength="4" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col v-if="this.form.numeroTarjeta.substring(0,2) != 34 && this.form.numeroTarjeta.substring(0,2) != 37 " sm="4" md="4" lg="4">
                    <b-form-group id="input-group-5" class="text-left" label-for="input-5">
                        <h6>CVV</h6>
                    <b-form-input id="input-5" v-model="form.cvvTarjeta" class="boderCVV inputInfo" type="password" placeholder="CVV"  maxlength="3" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col sm="7" md="7" lg="7" >
                   <!-- <b-alert v-model="noValida" class="text-center" variant="danger" dismissible><b-icon class="mr-1" icon="credit-card2-front"></b-icon> Tarjeta Invalida</b-alert>
                   <b-alert v-model="pagoRealizado" class="text-center" variant="success" dismissible><b-icon class="mr-1" icon="credit-card2-front"></b-icon> Pago Realizado</b-alert>
                   <b-alert v-model="pagoNoRealizado" class="text-center" variant="danger" dismissible><b-icon class="mr-1" icon="credit-card2-front"></b-icon> Pago no Realizado</b-alert>
                   <b-alert v-model="pagoCancelado" class="text-center" variant="warning" dismissible><b-icon class="mr-1" icon="credit-card2-front"></b-icon> Pago Cancelado</b-alert>
                   <b-alert v-model="errorConexion" class="text-center" variant="warning" dismissible><b-icon class="mr-1" icon="exclamation-triangle-fill"></b-icon> Error de Conexión</b-alert> -->
                   <!-- <b-button type="submit" variant="primary" class="button_H mt-3">PAGAR AHORA $3,000 MXN</b-button> -->
                   <b-button @click.prevent="pagar()" variant="primary" class="button_H mt-3">PAGAR AHORA ${{this.monto}} MXN</b-button>                   
                  </b-col>


                  <b-col col sm="10" md="10" lg="10" class="text-center mt-1">
                    <b-img src="../assets/verificado.png" style="width: 30px; height:auto;" alt=""></b-img> 
                    <span class="h6E">Tus pagos se realizan de forma segura.</span>
                  </b-col>
              </b-row>
              </b-form>        
            </b-col>
        </b-row>
            <!-- <b-overlay :show="busy" variant="light" opacity="0.90" no-wrap >
              <template #overlay>
                <div v-if="processing"  style="background-color: #CB0035" class="text-center text-light p-4 rounded">
                  <b-icon icon="credit-card2-front" font-scale="4"></b-icon>
                  <div class="mb-3"><h3> Pagando </h3></div>
                  <b-progress min="1" max="20" :value="counter" variant="danger" height="3px" class="mx-n4 rounded-0"></b-progress>
                </div>
                  
                <div v-else tabindex="-1" aria-modal="false" aria-labelledby="form-confirm-label" class="text-center p-3">
                  <h2 class="h2Confi"><strong id="form-confirm-label">Confirmar pago</strong></h2>
                  <div class="text-center">
                    <b-button variant="success" class="mr-3 button_confi" @click.prevent="pagar()">PAGAR</b-button>
                    <b-button variant="secondary" class="mr-3 button_confi2" @click="onCancel">NO PAGAR</b-button>
                  </div>
                </div>
              </template>
            </b-overlay> -->
        </div>

          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue';
import Descripcion from './Descripcion.vue';

export default {
  name: 'Formulario',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {

      monto: sessionStorage.getItem("montoWeb"),
      nombre: sessionStorage.getItem("nombre") +' '+sessionStorage.getItem("paterno")+' '+sessionStorage.getItem("materno"),
      telefono: sessionStorage.getItem("telefono"),
      mail: sessionStorage.getItem("mail"),
      contents: null,
      autos: [],
      photos: '',
      form: {
          nombreTitular: '',
          numeroTarjeta: '',
          mesTarjeta: '',
          anioTarjeta: '',
          cvvTarjeta: ''
        },
        show: true,
      };
  },

  methods: {
        onSubmit(event) {
            event.preventDefault();
        },

        onReset(event) {
            window.history.go(-2);
        },

        pagar(){
          this.$router.push({ path: '/Ticket'});
        },
        
        regresar(){
            window.history.go(-1);
        },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  },
  
  created() {

  },

}
</script>

<style scoped>


</style>